/**
 * @property cancelCallback
 * @property acceptedCallback
 * @property serviceEula
 */
export default function CustomerServiceAcceptanceDialogController(
  userService,
  ssDialogService,
  orgDataService,
  loaderService
) {
  const vm = this;
  vm.handleCloseDialogClick = handleCloseDialogClick;
  vm.handleAcceptServiceAgreementClick = handleAcceptServiceAgreementClick;

  function handleCloseDialogClick(avoidCallBack) {
    ssDialogService.hide(ssDialogService.dialogs.global.customerServiceAcceptance);
    if (avoidCallBack !== true && vm.cancelCallback) {
      vm.cancelCallback();
    }
  }

  function handleAcceptServiceAgreementClick() {
    const csa = {
      customerId: userService.user.customerId,
      serviceEulaId: vm.serviceEula.serviceEulaId,
      userId: userService.user.userId,
    };

    loaderService.showViewLoader = true;
    return orgDataService.acceptCSA(csa)
      .then((acceptCSAResponse) => {
        loaderService.showViewLoader = false;
        if (acceptCSAResponse.data.serviceEulaAcceptanceId > 0) {
          // Update Service Eula acceptance
          vm.serviceEula.isAccepted = true;
          handleCloseDialogClick(true);
          if (vm.acceptedCallback) {
            vm.acceptedCallback();
          }
        }
      });
  }
}

CustomerServiceAcceptanceDialogController.$inject = [
  'userService',
  'ssDialogService',
  'orgDataService',
  'loaderService'
];
